import React from 'react'

export const GoogleIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17.64} height={18} {...props}>
    <g fillRule="evenodd">
      <path
        data-name="Path 5444"
        d="M17.64 9.2a10.348 10.348 0 0 0-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.8 2.716v2.264h2.909A8.778 8.778 0 0 0 17.64 9.2Z"
        fill="#4285f4"
      />
      <path
        data-name="Path 5445"
        d="M9 18a8.592 8.592 0 0 0 5.956-2.181l-2.909-2.258a5.43 5.43 0 0 1-8.084-2.851H.957v2.332A9 9 0 0 0 9 18Z"
        fill="#34a853"
      />
      <path
        data-name="Path 5446"
        d="M3.964 10.71a5.32 5.32 0 0 1 0-3.42V4.958H.957a9.011 9.011 0 0 0 0 8.084Z"
        fill="#fbbc05"
      />
      <path
        data-name="Path 5447"
        d="M9 3.58a4.862 4.862 0 0 1 3.441 1.346l2.581-2.581A8.649 8.649 0 0 0 9 0 9 9 0 0 0 .957 4.958L3.964 7.29A5.364 5.364 0 0 1 9 3.58Z"
        fill="#ea4335"
      />
    </g>
  </svg>
)
